/**
 * Work Time Repository Implementation
 *
 * Implements WorkTimeRepository using workTimeDatasource.
 */

import type { WorkTimeType } from '../../domain/types';
import type { WorkTimeRepository } from '../../domain/repositories/workTimeRepository';
import { workTimeDatasource } from '../datasources';

export class WorkTimeRepositoryImpl implements WorkTimeRepository {
  async getWorkTime() {
    return workTimeDatasource.getWorkTime();
  }

  async updateWorkTime(newStatus: WorkTimeType) {
    return workTimeDatasource.updateWorkTime(newStatus);
  }
}

export const workTimeRepository: WorkTimeRepository = new WorkTimeRepositoryImpl();
